import Vue from 'vue'

export const eventHub = new Vue()